export default __webpack_public_path__ + "img/a7112e593ecaccc5618355aa1e8c714f.svg";